import {
  PricingFilterSection,
  PricingFilterSectionKind,
} from '@sales-portal/domain/pricing/blocs/utils/pricing-filter-types';

const DIACRITIC_RE = new RegExp('[\\u0300-\\u036f]', 'g');

const normalize = (value: string): string =>
  value.trim().normalize('NFD').replace(DIACRITIC_RE, '').toLowerCase();

export const filterSectionsBySearch = <T = unknown>(
  sections: PricingFilterSection<T>[],
  query: string,
): PricingFilterSection<T>[] => {
  const normalizedQuery = normalize(query);

  if (!normalizedQuery) {
    return sections;
  }

  return sections.reduce<PricingFilterSection<T>[]>((visible, section) => {
    const titleMatches = normalize(section.title).includes(normalizedQuery);

    if (section.kind !== PricingFilterSectionKind.Pill) {
      if (titleMatches) {
        visible.push(section);
      }
      return visible;
    }

    // A title match keeps every pill; otherwise only matching pills survive.
    if (titleMatches) {
      visible.push(section);
      return visible;
    }

    const options = section.options.filter((option) =>
      normalize(option.label).includes(normalizedQuery),
    );
    if (options.length > 0) {
      visible.push({ ...section, options });
    }

    return visible;
  }, []);
};
